import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { FiLogOut } from 'react-icons/fi';

export default function CarrierLayout() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-[#0F0A2B] font-sans text-white flex flex-col">
      <header className="bg-[#1A1F45] border-b border-[#2A2A4D] px-6 py-4 flex justify-between items-center">
        <h1 className="text-xl font-bold text-cyan-400">Dispax Carrier Portal</h1>
        <button onClick={handleLogout} className="flex items-center gap-2 text-red-400 hover:text-red-300">
          <FiLogOut /> Logout
        </button>
      </header>
      <main className="flex-1 p-6">
        <Outlet />
      </main>
    </div>
  );
}
